(function() {
  /* Contador de visitantes por versión (02/10): cada navegador cuenta UNA vez por prueba y versión, al ver
     la oferta de verdad. Va al Supabase del ERP de OK Perfumes desde el 03/11 (antes, «jaspe-datos»; esquema okp, función pública okp_ab_ver: solo suma, no guarda nada del
     cliente). Clave publicable, hecha para ir en la web. Quien fuerza versión con ?okpu= / ?okpd= (equipo,
     revisiones) queda marcado como «forzada» para siempre en ese navegador y el panel lo excluye.
     Detalle: docs/okp-pruebas-ab.md. */
  if (!window.okpVista) {
    try { if (/[?&](okpu|okpd)=/.test(location.search)) localStorage.setItem('okp_ab_forzada', '1'); } catch (e) {}
    window.okpForzada = function () { try { return localStorage.getItem('okp_ab_forzada') === '1'; } catch (e) { return false; } };
    window.okpVista = function (prueba, version) {
      try { var k = 'okpv_' + prueba + '_' + version; if (localStorage.getItem(k)) return; localStorage.setItem(k, '1'); } catch (e) { return; }
      fetch('https://qzemrdjzvspnfqljfjvo.supabase.co/rest/v1/rpc/okp_ab_ver', { method: 'POST', keepalive: true,
        headers: { apikey: 'sb_publishable_GuU0l8p7nwXIWrlw62FJVg_bm8gChpG', 'Content-Type': 'application/json' },
        body: JSON.stringify({ p_prueba: prueba, p_version: version, p_forzada: window.okpForzada() }) }).catch(function () {});
    };
  }
  const UPSELL_ID = 'okp-upsell-wrapper';
  // Escape HTML para títulos que van a innerHTML (blindaje contra '<' o '&' en nombres)
  const esc = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  // Parejas REALES de cesta (co-compra, 12 meses): si el carrito lleva un ancla, ofrece su
  // compañero PROBADO en 30 mL (8,95€). vid = variante 30 mL del compañero · ph = su handle
  // (para no ofrecer un perfume que ya llevas en otra medida). Ids verificados vía Admin API.
  const PARTNER = {
    'avt-aventus-de-creed-hombre':    { vid: 35607317971099, ph: 'svg-sauvage-de-dior-hombre' },   // AVT -> SVG (pareja nº1)
    'svg-sauvage-de-dior-hombre':     { vid: 35607274979483, ph: 'avt-aventus-de-creed-hombre' },  // SVG -> AVT
    'ivs-invictus-hombre':            { vid: 35607274979483, ph: 'avt-aventus-de-creed-hombre' },  // IVS -> AVT
    'oml-one-million-hombre':         { vid: 35607274979483, ph: 'avt-aventus-de-creed-hombre' },  // OML -> AVT
    'blc-bleu-de-chanel-hombre':      { vid: 35607274979483, ph: 'avt-aventus-de-creed-hombre' },  // BLC -> AVT
    'svx-sauvage-elixir-dior-hombre': { vid: 35607274979483, ph: 'avt-aventus-de-creed-hombre' },  // SVX -> AVT
    'pack-6-muestras':                { vid: 35607274979483, ph: 'avt-aventus-de-creed-hombre' },  // muestras -> "estrena la estrella"
    'pack-10-muestras':               { vid: 35607274979483, ph: 'avt-aventus-de-creed-hombre' }   // muestras -> AVT
  };

  // Perfume Misterioso (handle perfume-misterioso-30-ml): 3 variantes por género. El SKU va por
  // variante (XXF-30 / XXM-30 / XXN-30), así que eligiendo variante el SKU se asigna solo.
  // La tarjeta deja elegir y preselecciona según lo que ya lleva el carrito.
  const MISTERIOSO = {
    ids:    { femenino: 56011062116676, masculino: 56011062149444, unisex: 56618192634180 },
    labels: { femenino: 'Mujer',        masculino: 'Hombre',       unisex: 'Unisex' }
  };
  const MIST_ORDER = ['femenino', 'masculino', 'unisex'];
  const MIST_IDS = MIST_ORDER.map(g => MISTERIOSO.ids[g]);

  /* A/B de la primera tarjeta (ver cabecera): m = Misterioso (control) · p = Perfumador 5 mL. */
  const PERFUMADOR = 56778580001092;
  const PERFUME_TYPES_AB = ['Masculino', 'Femenino', 'Unisex'];
  /* ?okpd=m|p se guarda al cargar cualquier página (no solo cuando el carrito ya lleva un perfume). */
  try { const q = new URLSearchParams(location.search).get('okpd'); if (q === 'm' || q === 'p') localStorage.setItem('okpd_ab', q); } catch (e) {}
  function drawerArm() {
    try {
      let a = localStorage.getItem('okpd_ab');
      if (a !== 'm' && a !== 'p') { a = Math.random() < 0.5 ? 'm' : 'p'; localStorage.setItem('okpd_ab', a); }
      return a;
    } catch (e) { return 'm'; }   // sin almacenamiento: control, para no ensuciar la rama p
  }


  class OkpUpsellController {
    constructor(element) {
      this.el = element;
      this.listContainer = this.el.querySelector('#okp-upsell-list');

      // i18n sembrado desde Liquid (fallback ES por robustez)
      this.i18n = { add: 'Añadir', badge: '🧳 Formato viaje', travel_name: 'Tu <strong>{name}</strong>, también en 30 ml', family_badge: '👃 Huele como el tuyo', motor_badge: '⭐ Recomendado para ti', pair_badge: 'Se llevan juntos' };
      try {
        const t = this.el.querySelector('[data-okp-upsell-i18n]');
        if (t) this.i18n = Object.assign(this.i18n, JSON.parse(t.textContent));
      } catch(e){}

      this.productCache = {};   // handle -> /products/{handle}.js (evita re-fetch en cada refresh)
      this.recoCache = {};      // product_id -> recomendaciones enriquecidas (sección okp-reco-json)

      const rawIds = this.el.dataset.ids || '';
      this.variantIds = rawIds.split(',').map(s => s.trim()).filter(Boolean);

      this.init();
      this.bindEvents();
    }

    bindEvents() {
      if(this.el.dataset.bound) return;
      this.el.dataset.bound = 'true';
      // TODOS los caminos de add del tema: form PDP/quick-shop (ajaxProduct:added), rebuild del
      // drawer (cart:build), cambio de cantidades (cart:updated) y el refresh propio. Sin esto,
      // el upsell seguía ofreciendo un producto que ya acababas de añadir (línea duplicada).
      // Debounce: los eventos suelen llegar en ráfaga -> un único init.
      const kick = () => this.scheduleInit();
      const drawer = document.getElementById('CartDrawer');
      if (drawer) new MutationObserver(() => this.maybeMark()).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxProduct:added'].forEach(ev =>
        document.addEventListener(ev, kick));
    }

    scheduleInit() {
      clearTimeout(this._initT);
      this._initT = setTimeout(() => this.init(), 80);
    }

    /* Tarjeta inteligente: el perfume que ya lleva en grande (100/500/1L), en 30 mL.
       Prioriza el ítem de mayor importe (el que más le importa). */
    async travelPick(cart) {
      const PERFUME_TYPES = ['Masculino', 'Femenino', 'Unisex'];
      const BIG = /100|500|1\s?l/i;
      const inCart = cart.items.map(i => i.variant_id);
      const bigs = cart.items
        .filter(i => PERFUME_TYPES.includes(i.product_type) && BIG.test(i.variant_title || ''))
        .sort((a, b) => (b.final_line_price || b.line_price || 0) - (a.final_line_price || a.line_price || 0));
      for (const item of bigs) {
        try {
          // caché de PROMESAS: dos inits concurrentes no duplican el fetch del mismo handle
          const prod = await (this.productCache[item.handle] ||
            (this.productCache[item.handle] = fetch(`/products/${item.handle}.js`)
              .then(r => r.ok ? r.json() : Promise.reject(new Error('http')))));
          const v30 = (prod.variants || []).find(v => /(^|[^0-9])30([^0-9]|$)/.test(v.title || '') && v.available);
          if (!v30 || inCart.includes(v30.id)) continue;
          return {
            id: v30.id,
            nameHtml: this.i18n.travel_name.replace('{name}', () => esc(prod.title)),
            alt: prod.title,
            price: v30.price,
            compare_at_price: v30.compare_at_price,
            img: (v30.featured_image && v30.featured_image.src) || (prod.images && prod.images[0]) || '',
            kind: 'viaje-30ml',
            badge: this.i18n.badge
          };
        } catch(e){ delete this.productCache[item.handle]; }
      }
      return null;
    }

    /* Tarjeta "se llevan juntos": pareja REAL de cesta (co-compra 12m). Si el carrito lleva un
       ancla del mapa PARTNER (AVT/SVG/IVS/OML/BLC/SVX o packs de muestras), ofrece su compañero
       probado en 30 mL. No ofrece un perfume que ya llevas (en cualquier medida). Prioriza el
       ítem de mayor importe. Es el upsell más relevante -> va primero y destacado. */
    async partnerPick(cart, excludeIds) {
      const inCartVids = cart.items.map(i => i.variant_id);
      const inCartHandles = cart.items.map(i => i.handle);
      const srcs = cart.items
        .filter(i => PARTNER[i.handle])
        .sort((a, b) => (b.final_line_price || b.line_price || 0) - (a.final_line_price || a.line_price || 0));
      for (const src of srcs) {
        const p = PARTNER[src.handle];
        if (inCartHandles.includes(p.ph)) continue;                          // ya lo lleva en otra medida
        if (inCartVids.includes(p.vid) || excludeIds.includes(p.vid)) continue;
        const v = await this.fetchVariant(p.vid);
        if (!v || !v.available) continue;
        return {
          id: v.id,
          nameHtml: esc(v.name),
          alt: v.name,
          price: v.price,
          compare_at_price: v.compare_at_price,
          img: (v.featured_image && v.featured_image.src) || '',
          kind: 'pareja-30ml',
          badge: this.i18n.pair_badge
        };
      }
      return null;
    }

    /* Tarjeta "huele como el tuyo": motor de recomendaciones NATIVO de Shopify, enriquecido
       server-side por la sección okp-reco-json con el metafield familia_aromatica.
       Prioriza las que comparten familia con el perfume de mayor importe del carrito
       (match=true); fallback a la primera del motor (co-compra) con badge distinto. */
    async familyPick(cart, excludeIds) {
      const PERFUME_TYPES = ['Masculino', 'Femenino', 'Unisex'];
      const src = cart.items
        .filter(i => PERFUME_TYPES.includes(i.product_type))
        .sort((a, b) => (b.final_line_price || b.line_price || 0) - (a.final_line_price || a.line_price || 0))[0];
      if (!src) return null;
      try {
        // caché de PROMESAS por product_id (sin fetches duplicados en inits concurrentes)
        const recs = await (this.recoCache[src.product_id] ||
          (this.recoCache[src.product_id] = fetch(`/recommendations/products?section_id=okp-reco-json&product_id=${src.product_id}&limit=10&intent=related`)
            .then(async res => {
              if (!res.ok) throw new Error('http');
              const div = document.createElement('div');
              div.innerHTML = await res.text();
              return JSON.parse((div.textContent || '').trim());
            })));
        const inCart = cart.items.map(i => i.variant_id);
        const pool = (recs || []).filter(r => !inCart.includes(r.vid) && !excludeIds.includes(r.vid));
        if (!pool.length) return null;
        // El pool ya viene filtrado por género desde la sección (nunca femenino↔masculino),
        // así que con >=1 familia compartida el claim "Huele como el tuyo" es seguro
        // (PAX->PXI comparten solo "Floral" y son la misma línea). El mejor por nº de familias.
        const MIN_FAM = 1;
        const best = pool.reduce((a, b) => ((b.m || 0) > (a.m || 0) ? b : a), pool[0]);
        const isFam = (best.m || 0) >= MIN_FAM;
        const pick = isFam ? best : pool[0];   // sin familia común: co-compra del motor (mismo género)
        return {
          id: pick.vid,
          nameHtml: `${esc(pick.title)} · 30 ml`,
          alt: pick.title,
          price: pick.p,
          compare_at_price: pick.cap,
          img: pick.img,
          kind: isFam ? 'familia-30ml' : 'motor-30ml',
          badge: isFam ? this.i18n.family_badge : this.i18n.motor_badge
        };
      } catch(e) { delete this.recoCache[src.product_id]; return null; }
    }

    /* Género preseleccionado del Misterioso: manda lo que ya lleva el carrito (product_type
       Masculino/Femenino). Empate, mezcla o sin perfumes -> unisex, que nunca desentona. */
    pickGender(cart) {
      let m = 0, f = 0;
      (cart.items || []).forEach(i => {
        const t = String(i.product_type || '').toLowerCase();
        const q = i.quantity || 1;
        if (t === 'masculino') m += q;
        else if (t === 'femenino') f += q;
      });
      if (m > f) return 'masculino';
      if (f > m) return 'femenino';
      return 'unisex';
    }

    async init() {
      // Token de generación: si mientras este init esperaba fetches arranca otro más nuevo,
      // este NO pinta (evita repintar estado viejo encima del fresco).
      const gen = (this._gen = (this._gen || 0) + 1);
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        this.abAtributos(cart);
        const cartItems = cart.items.map(i => i.variant_id);

        /* ── Aquí NO van las tarjetas inteligentes ─────────────────────────
           travelPick, partnerPick y familyPick siguen escritas más arriba, pero
           el drawer ya no las llama. Ese trabajo —recomendar según lo que llevas—
           lo hace ahora el popup de la ficha (snippets/okp-upsell.liquid), que
           además tiene el motor nativo de Shopify por detrás y llega a todo el
           catálogo, no a un mapa de seis productos.

           El drawer se queda con un solo oficio: la COMPRA A CIEGAS. Misterioso
           y los dos packs "nosotros elegimos". Es el momento correcto para eso:
           el cliente ya ha decidido qué se lleva y está mirando el total, no
           evaluando alternativas.

           Si algún día hiciera falta recuperarlas aquí, basta con volver a
           llamarlas y hacer unshift de sus tarjetas como estaba antes. */
        const travel = null, partner = null, family = null;

        this.mistGender = this.pickGender(cart);
        /* BRU62 (bruma Cheirosa 62) fuera del drawer el 28/09: 0 ventas en 3 semanas (29/08–20/09),
           texto «del verano» caducado y descargaba la ficha entera en cada carrito femenino. */

        // A/B: en la rama p (y con un perfume en el carrito) el Perfumador ocupa el sitio del Misterioso.
        const conPerfume = cart.items.some(i => PERFUME_TYPES_AB.includes(i.product_type));
        const armP = conPerfume && drawerArm() === 'p';
        this.abArm = !conPerfume ? 'fuera' : (armP ? 'perfumador' : 'misterioso');
        let ids = this.variantIds;
        if (armP) ids = [String(PERFUMADOR)].concat(ids.filter(id => MIST_IDS.indexOf(parseInt(id)) === -1));

        // 2) Relleno estático (Misterioso primero): fuera lo del carrito o lo que dupliquen las inteligentes
        let candidates = ids.filter(id => !cartItems.includes(parseInt(id)));
        // Misterioso: si ya lleva CUALQUIER género en el carrito, no se re-ofrece (no solo el unisex)
        if (MIST_IDS.some(mid => cartItems.includes(mid))) {
          candidates = candidates.filter(id => MIST_IDS.indexOf(parseInt(id)) === -1);
        }
        if (travel) candidates = candidates.filter(id => parseInt(id) !== travel.id);
        if (partner) candidates = candidates.filter(id => parseInt(id) !== partner.id);
        if (family) candidates = candidates.filter(id => parseInt(id) !== family.id);
        // Con el pack de 6 muestras de regalo ya en el carrito, no se ofrece el de pago (47920290300228).
        const regaloVid = parseInt(this.el.dataset.regalo || 0, 10);
        if (regaloVid && cartItems.includes(regaloVid)) candidates = candidates.filter(id => parseInt(id) !== 47920290300228);

        // El popup de ficha (okp-upsell) acaba de enseñar estas al añadir al
        // carrito: no repetirlas cinco segundos después. El Misterioso NO entra
        // en esa marca a propósito — ahí funciona bien y se sigue ofreciendo.
        try {
          const yaOfrecidas = (sessionStorage.getItem('okpu_offered') || '')
            .split(',').filter(Boolean).map(Number);
          if (yaOfrecidas.length) {
            candidates = candidates.filter(id => yaOfrecidas.indexOf(parseInt(id)) === -1);
          }
        } catch (e) {}

        const results = await Promise.all(candidates.map(id => this.fetchVariant(id)));
        let cards = results.filter(v => v && v.available).map(v => (v.id === PERFUMADOR ? {
          id: v.id,
          nameHtml: esc(this.i18n.pf_name || v.name),
          alt: this.i18n.pf_name || v.name,
          price: v.price,
          compare_at_price: v.compare_at_price,
          img: (v.featured_image && v.featured_image.src) || '',
          kind: 'drawer-perfumador',
          badge: this.i18n.pf_tag || null
        } : {
          id: v.id,
          nameHtml: esc((this.i18n.nm || {})[v.id] || v.name),   /* packs: nombre corto en vez del título en mayúsculas */
          alt: (this.i18n.nm || {})[v.id] || v.name,
          price: v.price,
          compare_at_price: v.compare_at_price,
          img: (v.featured_image && v.featured_image.src) || '',
          kind: 'clasico',
          badge: (this.i18n.nm || {})[v.id] ? (this.i18n.tg_pk || null) : null
        }));

        if (family) cards.unshift(family);
        if (travel) cards.unshift(travel);
        if (partner) cards.unshift(partner);   // primero: la pareja real de cesta es el upsell más relevante

        /* ── UNA sola oferta, y cuál depende de lo que pasó en el popup de ficha ──
           Apilar cuatro no da cuatro oportunidades, da parálisis: cuatro decisiones
           donde el cliente venía a tomar cero. Y además el Misterioso y el pack
           "nosotros elegimos" disparan EL MISMO mecanismo —comprar a ciegas—, así
           que encadenarlos en diez segundos quema el gancho en vez de doblarlo.

             · se llevó el Misterioso arriba -> aquí el par de cesta, nunca muestras
             · vio el popup y no cogió nada  -> aquí las 6 muestras "no eliges"
             · no llegó a ver el popup       -> la mejor tarjeta que haya

           El estado lo deja snippets/okp-upsell.liquid en sessionStorage al añadir. */
        /* ── Las tres, siempre, y en este orden ────────────────────────────
           Misterioso · pack de 6 "nosotros elegimos" · pack de 20. Es una escalera
           de ticket (6,95 → 8,95 → 19,95) del mismo gesto: comprar a ciegas. No se
           elige una por el cliente porque aquí la elección ES la oferta —cuánto se
           quiere arriesgar—, y eso solo lo sabe él.

           No hace falta filtrar nada a mano: `candidates` ya viene sin lo que está
           en el carrito, y el Misterioso se cae solo si ya lleva CUALQUIERA de sus
           tres géneros (arriba). Si se llevó uno en el popup de la ficha, aquí no
           reaparece.

           El orden lo fija `upsell_config_ids` en la cabecera de este archivo. */

        if (gen !== this._gen) return;   // llegó tarde: otro init más nuevo ya pintó

        if (cards.length > 0) {
          this.renderList(cards);
          this.el.style.display = 'block';
          this._pending = { cart, cards };
          this.maybeMark();
        } else {
          this.el.style.display = 'none';
        }
      } catch (err) {
        console.error('OKP Upsell Error:', err);
        if (gen === this._gen) this.el.style.display = 'none';
      }
    }

    /* MEDICIÓN (28/09): el popup de ficha ya deja okp_upsell_shown; el drawer no tenía denominador.
       Atributo de CARRITO okp_cart_upsell_shown = 'v1|id,id,…' con lo que se enseñó. Llega al pedido
       como note_attribute. Tasa del drawer = pedidos con línea _okp_upsell 'clasico'/'misterioso-*'
       ÷ pedidos con este atributo. Atributo y no propiedad de línea: no parte líneas (ver okp-upsell).
       Solo se escribe si cambia, con fetch directo (sin eventos del tema → sin bucle con bindEvents). */
    /* Pruebas de otras páginas (p. ej. talla preseleccionada en la ficha, okp-ab-talla): dejan su versión en
       localStorage al exponer al visitante y aquí se copia al atributo del carrito, una vez, para que el pedido
       diga qué vio aunque compre desde otra página. Este script corre en todas las páginas. */
    abAtributos(cart) {
      try {
        if (!cart || !cart.item_count || this._abAttrs) return;
        const at = cart.attributes || {}, nuevo = {};
        /* La prueba de talla se cerró el 19/10: no se copia más y se limpia lo que dejó en el navegador. */
        try { localStorage.removeItem('okp_talla_ab'); localStorage.removeItem('okpt_ab'); } catch (e) {}
        if (window.okpForzada() && !at.okp_ab_forzada) nuevo.okp_ab_forzada = '1';
        if (!Object.keys(nuevo).length) return;
        this._abAttrs = true;
        fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: nuevo }) }).catch(() => { this._abAttrs = false; });
      } catch (e) {}
    }

    /* EXPOSICIÓN REAL (02/10): antes se marcaba «enseñado» al cargar cualquier página con productos en el
       carrito, aunque nadie abriera el carrito (el popup de ficha lleva a «Ir a pagar» directo). El panel
       dividía entre pedidos que nunca vieron la oferta. Ahora solo cuenta cuando el carrito está abierto
       (drawer) o en /cart. Valor 'v2|…': el panel lee solo v2. */
    visible() {
      if (this.el.closest('.okp-cart-v2')) return true;
      const d = document.getElementById('CartDrawer');
      return !!(d && d.classList.contains('drawer--is-open') && this.el.offsetParent !== null);
    }
    maybeMark() {
      if (this._pending && this.visible()) {
        const p = this._pending; this._pending = null;
        if (this.abArm) window.okpVista('drawer', this.abArm);
        this.markShown(p.cart, p.cards);
      }
    }
    markShown(cart, cards) {
      try {
        if (!cart || !cart.item_count) return;
        const val = 'v2|' + cards.map(c => c.id).join(',');
        /* UNA vez por carrito (29/09): antes se reescribía cada vez que cambiaban las sugerencias, o
           sea tras cada añadido, y cada escritura le cuesta a Shopify ~0,5 s en los que «Pagar» o
           otro «+» esperan en cola. Para el denominador basta saber que se enseñaron; se guarda la
           primera lista. */
        /* Se reescribe si el carrito traía la marca vieja (v1, por carga de página) o no llevaba versión del
           A/B: carritos creados antes del 01/10 se quedaban sin okp_drawer_ab. */
        const at = cart.attributes || {};
        if (this._shown || (String(at.okp_cart_upsell_shown || '').indexOf('v2|') === 0 && at.okp_drawer_ab)) return;
        this._shown = val;
        fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes: Object.assign({ okp_cart_upsell_shown: val, okp_drawer_ab: this.abArm || 'fuera' }, window.okpForzada() ? { okp_ab_forzada: '1' } : {}) })
        }).catch(() => { this._shown = null; });
      } catch (e) {}
    }

    async fetchVariant(id) {
      try {
        /* Con la raíz del idioma (/en/, /fr/, /pt-pt/): sin ella Shopify devolvía el nombre en español
           en todos los idiomas. */
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(`${root}variants/${id}.js`);
        if (!res.ok) return null;
        return await res.json();
      } catch(e) { return null; }
    }

    renderList(cards) {
      this.listContainer.innerHTML = '';
      this.listContainer.scrollLeft = 0;

      // Sirve la imagen al tamaño que se muestra (56px → 160px para retina) vía el CDN de Shopify.
      // Evita bajar imágenes de 2000px para un thumbnail. (1 sola width; quita las previas.)
      const sized = (url, w) => {
        if (!url || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
        url = url.replace(/[?&]width=\d+/g, '');
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      };

      // Formato es-ES: coma decimal ("12,95 €")
      const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' €';

      // Imágenes que pone Shopify (ver el <script data-okp-upsell-imgs> de arriba). Sustituye al
      // mapa de URLs a mano: cubre cualquier variante sin imagen propia y no se desincroniza.
      const IMGS = (() => {
        try { const t = document.querySelector('[data-okp-upsell-imgs]');
              return t ? JSON.parse(t.textContent) : {}; } catch(e){ return {}; }
      })();

      cards.forEach(c => {
        // Precio: el tachado (si lo hay) encima, pequeño; si no, el tamaño cuando se sabe.
        const antes = c.compare_at_price > c.price ? `<s>${fmt(c.compare_at_price)}</s>` : '';

        // Manda la imagen viva de la variante; si no tiene, la del producto; y solo entonces
        // el placeholder. Antes se saltaba el paso de en medio y salía el gris.
        let img = c.img || IMGS[c.id] || IMGS[String(c.id)] ||
                  'https://cdn.shopify.com/s/images/admin/no-image-large.gif';

        // Misterioso: tarjeta con selector de género (el SKU va por variante, se asigna solo)
        const isMist = MIST_IDS.indexOf(c.id) > -1;
        const selG = isMist ? (this.mistGender || 'unisex') : null;
        // El nombre de la variante trae el sufijo del género ("... - unisex"); con selector, sobra
        const nameHtml = isMist
          ? esc((this.i18n.nm && this.i18n.nm.mist) || String(c.alt || '').replace(/\s+-\s+[^-]+$/, ''))   /* fuera el sufijo del género, en cualquier idioma */
          : c.nameHtml;
        const gendersHtml = isMist
          ? `<div class="okp-uc__gen" role="group" aria-label="${esc(this.i18n.g_label || 'Elige el género')}">`
            /* En la tarjeta (media anchura) «Mujer · Hombre · Unisex» no cabe: chip corto (Ella · Él), aria-label completo. */
            + MIST_ORDER.map(g => `<button type="button" class="okp-gender${g === selG ? ' is-on' : ''}" data-g="${g}" aria-pressed="${g === selG}" aria-label="${esc((this.i18n.g || MISTERIOSO.labels)[g])}">${esc((this.i18n.g_short || MISTERIOSO.labels)[g])}</button>`).join('')
            + `</div>`
          : '';
        // Etiqueta corta sobre el nombre: la de la tarjeta (si trae) o «Perfume sorpresa» en el Misterioso.
        const tag = c.badge || (isMist ? this.i18n.sorpresa : '');

        // La primera tarjeta lleva el borde animado de la campaña.
        const isFeat = !this.listContainer.children.length;
        const card = document.createElement('div');
        card.className = 'okp-uc__card' + (isFeat ? ' is-feat' : '');
        card.setAttribute('role', 'listitem');
        /* El type="button" del CTA NO es decorativo: sin él el navegador lo toma
           como submit, y esta tarjeta vive dentro de #CartDrawerForm. Al pulsar Enter
           con el foco en un campo de cantidad, el envío implícito de HTML dispara un
           clic sintético sobre el botón por defecto: se añadía la oferta al carrito
           sin que el cliente pulsara nada. */
        card.innerHTML = `
          <img src="${sized(img, 480)}" loading="lazy" decoding="async" width="480" height="448" class="okp-uc__img" alt="${(c.alt || '').replace(/"/g, '&quot;')}">
          <div class="okp-uc__body">
            ${tag ? `<span class="okp-uc__tag">${esc(tag)}</span>` : ''}
            <div class="okp-uc__name">${nameHtml}</div>
            ${gendersHtml}
            <div class="okp-uc__price">${antes}${fmt(c.price)}</div>
            <button type="button" class="okp-uc__btn" data-add="${c.id}" aria-label="${esc(this.i18n.add + ' ' + (c.alt || ''))}">${this.i18n.add}</button>
          </div>
        `;

        // OJO: los chips también son <button>, así que hay que apuntar a la clase del CTA
        const btn = card.querySelector('.okp-uc__btn');
        if (isMist) {
          card.dataset.gender = selG;
          const chips = card.querySelectorAll('.okp-gender');
          chips.forEach(ch => {
            ch.onclick = () => {
              chips.forEach(x => { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
              ch.classList.add('is-on');
              ch.setAttribute('aria-pressed', 'true');
              card.dataset.gender = ch.dataset.g;
            };
          });
          btn.onclick = (e) => {
            const g = card.dataset.gender || 'unisex';
            this.addToCart(e, MISTERIOSO.ids[g], 'misterioso-' + g, c.price);
          };
        } else {
          btn.onclick = (e) => this.addToCart(e, c.id, c.kind || 'clasico', c.price);
        }

        this.listContainer.appendChild(card);
      });
    }

    /* source: 'viaje-30ml' (tarjeta inteligente) | 'clasico' (lista estática).
       Se registra en DOS sitios: propiedad oculta _okp_upsell en la línea del pedido
       (atribución de ingresos exacta en admin/exports; el _ la oculta en checkout y el
       drawer no pinta properties) + evento dataLayer para GA4 vía GTM. */
    async addToCart(e, id, source, priceCents) {
      const btn = e.currentTarget || e.target;
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1, properties: { _okp_upsell: source } })
        });
        const data = await res.json().catch(() => ({}));
        // 422 (agotado/límite) NO es éxito: sin evento GA4 falso y con feedback al usuario
        if (!res.ok || (data && data.status)) throw new Error('add-failed');
        try {
          if (window.dataLayer) window.dataLayer.push({
            event: 'add_to_cart', source: 'okp-upsell-' + source,
            value: (priceCents || 0) / 100, currency: 'EUR'
          });
        } catch(err) {}
        btn.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        // la disponibilidad pudo cambiar a mitad de sesión: invalidar cachés y re-evaluar la lista
        this.productCache = {};
        this.recoCache = {};
        btn.classList.add('is-error');
        setTimeout(() => {
            btn.classList.remove('is-error');
            btn.disabled = false;
        }, 2000);
        this.scheduleInit();
      }
    }
  }

  /* Carrusel: un paso = una página de 2 tarjetas (3 en /cart en PC). Flechas y arrastre con
     ratón; en táctil, el dedo. Los puntos dicen en qué página estás. */
  function navCarrusel(wrap) {
    const list = wrap.querySelector('.okp-uc__list');
    const prev = wrap.querySelector('[data-okp-uc-dir="-1"]'), next = wrap.querySelector('[data-okp-uc-dir="1"]');
    const dots = wrap.querySelector('.okp-uc__dots');
    if (!list || !prev || !next) return;
    const porVista = () => { const c = list.querySelector('.okp-uc__card'); return c ? Math.max(1, Math.round(list.clientWidth / c.getBoundingClientRect().width)) : 2; };
    const paso = () => { const c = list.querySelector('.okp-uc__card'); return c ? (c.getBoundingClientRect().width + 10) * porVista() : 300; };
    const estado = () => {
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      if (!dots || !list.clientWidth) return; /* oculto (drawer cerrado): no medir */
      const n = Math.ceil(list.querySelectorAll('.okp-uc__card').length / porVista());
      if (n < 2) { dots.innerHTML = ''; return; }
      if (dots.children.length !== n) dots.innerHTML = new Array(n + 1).join('<i class="okp-uc__dot"></i>');
      const fin = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      const on = fin ? n - 1 : Math.round(list.scrollLeft / paso());
      for (let i = 0; i < n; i++) dots.children[i].classList.toggle('is-on', i === on);
    };
    [prev, next].forEach(b => b.addEventListener('click', e => {
      e.preventDefault();
      list.scrollBy({ left: paso() * Number(b.getAttribute('data-okp-uc-dir')), behavior: 'smooth' });
    }));
    list.addEventListener('scroll', estado, { passive: true });
    new MutationObserver(estado).observe(list, { childList: true });
    if (window.ResizeObserver) new ResizeObserver(estado).observe(list); /* al abrir el drawer o pasar a /cart */
    estado();
    let x0 = 0, s0 = 0, abajo = false, movido = false;
    list.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button')) return;
      abajo = true; movido = false; x0 = e.clientX; s0 = list.scrollLeft;
    });
    window.addEventListener('pointermove', e => {
      if (!abajo) return;
      const dx = e.clientX - x0;
      if (!movido && Math.abs(dx) > 5) { movido = true; list.classList.add('is-drag'); }
      if (movido) list.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!abajo) return;
      abajo = false;
      if (movido) {
        setTimeout(() => list.classList.remove('is-drag'), 0);
        const c = paso(); list.scrollTo({ left: Math.round(list.scrollLeft / c) * c, behavior: 'smooth' });
      }
    });
    list.addEventListener('click', e => { if (list.classList.contains('is-drag')) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* Modo fijo: al pie del drawer, encima del subtotal (ver CSS). Solo si el nodo está en #CartDrawer y no
     estamos en /cart (allí main-cart-v2 lo lleva a su columna). El plegado se recuerda en la sesión. */
  function dock(el) {
    const foot = el.closest('#CartDrawer') && document.querySelector('#CartDrawer .drawer__footer');
    if (!foot || document.querySelector('.okp-cart-v2')) return;
    /* Ya colocado: nada que hacer. (Antes recalculaba estilos —getComputedStyle— en cada cambio de la
       página: miles de veces mientras cargan las apps, ~14 s de CPU en un móvil medio. 02/10) */
    if (el.dataset.dock && el.parentElement === foot) return;
    if (el.parentElement !== foot) foot.insertBefore(el, foot.firstChild);
    const cs = getComputedStyle(foot);
    el.style.setProperty('--okd-x', cs.paddingLeft);
    el.style.setProperty('--okd-t', cs.paddingTop);
    if (el.dataset.dock) return;
    el.dataset.dock = '1';
    el.classList.add('okp-uc--dock');
    const title = el.querySelector('.okp-uc__title');
    const peek = document.createElement('span');
    peek.className = 'okp-uc__peek';
    title.after(peek);
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    const set = (closed) => {
      el.classList.toggle('is-closed', closed);
      title.setAttribute('aria-expanded', String(!closed));
      try { sessionStorage.setItem('okp_dock_closed', closed ? '1' : '0'); } catch (e) {}
    };
    let closed = false;
    try { closed = sessionStorage.getItem('okp_dock_closed') === '1'; } catch (e) {}
    set(closed);
    const toggle = () => set(!el.classList.contains('is-closed'));
    [title, peek].forEach(t => t.addEventListener('click', toggle));
    title.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    /* «3 ideas · desde 4,95 €» para la línea plegada, al día con las tarjetas pintadas. */
    const list = el.querySelector('.okp-uc__list');
    const resumen = () => {
      const cards = list.querySelectorAll('.okp-uc__card');
      const precios = [...list.querySelectorAll('.okp-uc__price')].map(p => p.lastChild && p.lastChild.textContent).filter(Boolean);
      const min = precios.map(t => parseFloat(t.replace(/[^\d,]/g, '').replace(',', '.'))).filter(n => !isNaN(n)).sort((a, b) => a - b)[0];
      let from = 'desde';
      try { from = JSON.parse(el.querySelector('[data-okp-upsell-i18n]').textContent).from || from; } catch (e) {}
      peek.textContent = cards.length && min ? `${from} ${min.toFixed(2).replace('.', ',')} €` : '';
    };
    new MutationObserver(resumen).observe(list, { childList: true });
    resumen();
  }

  function boot() {
    const el = document.getElementById(UPSELL_ID);
    if (el && !el.dataset.ready) {
      el.dataset.ready = 'true';
      new OkpUpsellController(el);
      navCarrusel(el);
    }
    if (el) dock(el);
  }

  boot();
  document.addEventListener('DOMContentLoaded', boot);
  /* Como mucho una vez por fotograma, no una por cada nodo que añaden las apps al cargar. */
  let bootPend = false;
  new MutationObserver(() => {
    if (bootPend) return;
    bootPend = true;
    requestAnimationFrame(() => { bootPend = false; if (document.getElementById(UPSELL_ID)) boot(); });
  }).observe(document.body, { childList: true, subtree: true });

})();
